import React from "react";
import { NavLink } from "react-router-dom";
import AuthService from "../AuthContext/AuthService";
import "./Sidebar.css";

const Sidebar = ({ isVisible, closeSidebar }) => {
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  };

  return (
    <div
      className={`custom-sidebar ${isVisible ? "" : "custom-sidebar-hidden"}`}
    >
      <ul className="sidebar-menu">
        <li>
          <NavLink
            to="/Generate-Form"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-objects-column"></i>
            <span>Generate Form</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/Forms-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-paperclip"></i>
            <span>Forms List</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Forms-Sets-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-thumbtack"></i>
            <span>FormSets List</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Filter-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-filter"></i>
            <span>Filters List</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Filled-Forms-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-briefcase"></i>
            <span>Data List</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Excel"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-file-excel"></i>
            <span>Excel</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Databases"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-database"></i>
            <span>Databases</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Users-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-users"></i>
            <span>Users</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/History-Logs"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-history"></i>
            <span>Activity Logs</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Profile"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-user"></i>
            <span>Profile</span>
          </NavLink>
        </li>
        <li className="sidebar-logout">
          <a
            href="/login"
            className="sidebar-item logout-button"
            onClick={AuthService.logout}
          >
            <i className="pi pi-sign-out"></i>
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
